import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'

import { createUser } from '../../api/users.js'
import { useFeedback } from '../../components/ui/FeedbackProvider.jsx'

const ROLE_OPTIONS = [
  { value: 'Viewer', label: 'Viewer' },
  { value: 'Support', label: 'Support' },
  { value: 'QA', label: 'QA' },
  { value: 'Game Designer', label: 'Game Designer' },
  { value: 'Producer', label: 'Producer' },
  { value: 'Admin', label: 'Admin' },
]

export default function UserCreatePage() {
  const navigate = useNavigate()
  const { toast } = useFeedback()
  const [values, setValues] = useState({
    email: '',
    role: 'Viewer',
  })
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [error, setError] = useState(null)

  function onChange(field) {
    return (e) =>
      setValues((prev) => ({
        ...prev,
        [field]: e.target.value,
      }))
  }

  function handleRoleSelect(role) {
    setValues((prev) => ({ ...prev, role }))
  }

  async function handleSubmit(e) {
    e.preventDefault()
    if (isSubmitting) return
    const emailTrimmed = values.email.trim()
    if (!emailTrimmed) {
      setError(new Error('Email is required.'))
      return
    }
    setError(null)
    setIsSubmitting(true)
    try {
      await createUser({
        email: emailTrimmed.toLowerCase(),
        role: values.role,
      })
      toast({ type: 'success', message: 'User created.' })
      navigate('/users')
    } catch (err) {
      setError(err)
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <div className="page">
      <div className="pageHeader">
        <h1 className="pageTitle">Create user</h1>
        <Link to="/users" className="button buttonGhost">
          Back
        </Link>
      </div>

      <section className="card formCard">
        <div className="cardTitle">User</div>
        <form className="formGrid" onSubmit={handleSubmit}>
          <label className="formField">
            <span className="formLabel">Email</span>
            <input
              className="textInput"
              type="email"
              value={values.email}
              onChange={onChange('email')}
              placeholder="user@example.com"
              required
            />
          </label>

          <label className="formField">
            <span className="formLabel">Role</span>
            <div className="platformSelector" role="radiogroup" aria-label="Role">
              {ROLE_OPTIONS.map((opt) => (
                <button
                  key={opt.value}
                  type="button"
                  className={`platformSelectorOption ${values.role === opt.value ? 'platformSelectorOptionActive' : ''}`}
                  onClick={() => handleRoleSelect(opt.value)}
                  aria-pressed={values.role === opt.value}
                  disabled={isSubmitting}
                >
                  {opt.label}
                </button>
              ))}
            </div>
          </label>

          <div className="formActions">
            <button type="submit" className="button buttonPrimary" disabled={isSubmitting}>
              {isSubmitting ? 'Creating...' : 'Create'}
            </button>
          </div>
        </form>

        {error ? (
          <div className="formError">
            {error?.body?.detail || error?.message || 'Failed to create user.'}
          </div>
        ) : null}
      </section>
    </div>
  )
}
